import * as PIXI from "pixi.js";
import { eventBus, EnumEventBus } from "../managers/EventBus";
import Layers from "../../../../../src/layers/Layers";
import TextureManager from "../../../../../src/managers/TextureManager";
import { CAT_ASSET } from "../types/Config";
import { Coord } from "../../../../../src/types/Interface";
import getAngleBetweenPoints from "../../../../../src/utils/math/getAngleBtwPoints";
import SwapSprite from "../../../../../src/animation/SwapSprite";
import generatePoints from "../../../../../src/utils/generator/generatePoints";
import { INITIAL_CIRCLE_RADIUS } from "../../../../../src/types/Config";


export default class Cat extends PIXI.Container {
  private Layers = Layers.getInstance();
  private earLeft!: PIXI.Sprite;
  private earRight!: PIXI.Sprite;
  private noise!: PIXI.Sprite;

  constructor(
    private cCoord: Coord
  ) {
    super();
    this.addSprites();
    this.addToLayer();
    this.setVisible(false, true);

    eventBus.on(EnumEventBus.catMode, v => this.setVisible(v));
  }

  addToLayer = () => this.Layers.Middle.addChild(this);
  setVisible(v: boolean, noAnimation:boolean = false) {
    const onUpdate = (elm: PIXI.Sprite, v: number) => elm.scale.set(v);
    [this.earLeft, this.earRight, this.noise].forEach(catPart => {
      if(noAnimation){
        catPart.visible = v;
        return
      }
      catPart.scale.set(v ? .4 : .8);
      v ? catPart.visible = v : "";
      v 
        ? new SwapSprite(.4, .8, (v: number) => onUpdate(catPart, v))
        : new SwapSprite(.8, .4, (v: number) => onUpdate(catPart, v), () => catPart.visible = v);
    })
  }

  addSprites() {
    const texture = TextureManager.getTexture(CAT_ASSET) as any;//258pxx195px

    this.earLeft = this.addSprite(texture, { x: 0, y: 0, w: 110, h: 100 });
    this.earRight = this.addSprite(texture, { x: 258 - 115, y: 0, w: 110, h: 100 });
    this.noise = this.addSprite(texture, { x: 0, y: 125, w: 258, h: 70 });
  }
  updateCoord(radians: number[]) {
    const offset = [-Math.PI / 2 * .85, -Math.PI / 2 * 1.15];
    const pointsCoord = generatePoints(this.cCoord, radians, INITIAL_CIRCLE_RADIUS + 25);
    [this.earLeft, this.earRight].forEach((e, eI) => {
      const c = pointsCoord[eI];

      Object.assign(e, c);
      e.rotation = getAngleBetweenPoints(c, this.cCoord) + offset[eI];
    });

    const deltaPoint = { x: (pointsCoord[0].x + pointsCoord[1].x) / 2, y: (pointsCoord[0].y + pointsCoord[1].y) / 2 }
    Object.assign(this.noise, this.cCoord);
    this.noise.rotation = getAngleBetweenPoints(deltaPoint, this.cCoord) - Math.PI / 2;
  }

  addSprite(source: any, bounds: { x: number, y: number, w: number, h: number }) {
    const frame = new PIXI.Rectangle(bounds.x, bounds.y, bounds.w, bounds.h);
    const texture = new PIXI.Texture({ source, frame });
    const sprite = new PIXI.Sprite(texture);
    sprite.x = -250;
    sprite.y = -250;
    sprite.anchor.set(.5);
    return this.addChild(sprite);
  }
}